import backIcon from '@assets/images/back.svg';
import { Loading, ModalError } from '@components';
import PlantFormContainer from '@components/PlantFormWrapper/PlantFormWrapper';
import { ROUTES } from '@constants';
import useGetPlantDetail from '@hooks/plants/useGetPlantDetail';
import {useGetFeatures} from '@hooks';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Style } from './style';
import { FEATURE } from '@constants';
import { plant } from '@assets';
import { hasFeature } from '@helpers/dashboard';

const PlantDetailContainer = () => {
  const { plantId } = useParams();
  const { isLoading, data, isFetching, isStale, isSuccess } = useGetPlantDetail(plantId);
  const { isLoading: isFeatureLoading, data: featureList } = useGetFeatures()


  const navigate = useNavigate();
  const goBack = () => navigate(ROUTES.PLANT_LIST, { replace: true });
  const onCloseModal = () => navigate(ROUTES.PLANT_LIST);

  if (isLoading || (isFetching && !isStale) || isFeatureLoading) {
    return <Loading />;
  }

  const isNotFound = isSuccess && data.status === 'not-found';
  const isAllowUpdateStatus = !isFeatureLoading && hasFeature(featureList, FEATURE.DASHBOARD_MANAGEMENT)
  if(!isAllowUpdateStatus && data.plant) {
    delete data.plant.is_active
  }

  return (
    <Style>
      <React.Fragment>
        <div className='btn-back' onClick={goBack}>
          <img className='back' src={backIcon} alt={'back.svg'} />
          Back
        </div>
        <div className='detail'>{data.plant && <PlantFormContainer plant={data.plant} isAllowUpdateStatus={isAllowUpdateStatus} />}</div>
      </React.Fragment>
      {isNotFound && <ModalError isDisplay={isNotFound} content={` Can't find your plant.`} closeModal={onCloseModal} />}
    </Style>
  );
};

export default PlantDetailContainer;
